<mat-dialog-content>
    <h4>Pixelfehler Auswertung</h4>
<span class="text-danger">Hinweis: Pixelfehler können nur ihrer Spalte zugeordnet werden</span>
    <div *ngFor="let pixelFehler of pixelSpaltenResults">
        {{pixelFehler.timestamp}}
        <div class="d-flex flex-row" *ngFor="let row of imageHeightArray; let ir = index">
            <div *ngFor="let column of imageWidthArray; let ic = index "
                style="height: 10px; width: 10px; border: 1px solid black;"
                [ngClass]="checkIfPixelErrorExists(ic + 1, ir + 1, pixelFehler.pixelSpalten) ? 'error-class' : 'normal-class'">
                <span style="font-size: 8px;"> </span>
            </div>
        </div>
    </div>

</mat-dialog-content>